export default "__VITE_ASSET__Czq4Uq$U__"